export function restoreCasingInHighlight(highlightStr: string, sourceValue: string): string {
	const plainLower = highlightStr.replace(/<\/?em>/g, '').toLowerCase();
	if (plainLower !== sourceValue.toLowerCase()) {
		return highlightStr;
	}

	let result = '';
	let sourceIdx = 0;
	let i = 0;

	while (i < highlightStr.length) {
		if (highlightStr.startsWith('<em>', i)) {
			result += '<em>';
			i += 4;
		} else if (highlightStr.startsWith('</em>', i)) {
			result += '</em>';
			i += 5;
		} else {
			result += sourceValue[sourceIdx];
			sourceIdx++;
			i++;
		}
	}

	return result;
}
